import React, { Component } from 'react';
import { HomeIcon, ClockIcon, WalletIcon, UserIcon, MapIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
export const BottomNav: React.FC = () => {
  const location = useLocation();
  const {
    isDriverMode
  } = useApp();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const passengerNavItems = [{
    icon: HomeIcon,
    label: 'Home',
    path: '/'
  }, {
    icon: MapIcon,
    label: 'Directory',
    path: '/directory'
  }, {
    icon: ClockIcon,
    label: 'Bookings',
    path: '/bookings'
  }, {
    icon: WalletIcon,
    label: 'Wallet',
    path: '/wallet'
  }, {
    icon: UserIcon,
    label: 'Profile',
    path: '/profile'
  }];
  const driverNavItems = [{
    icon: HomeIcon,
    label: 'Home',
    path: '/driver'
  }, {
    icon: ClockIcon,
    label: 'Rides',
    path: '/driver/rides'
  }, {
    icon: WalletIcon,
    label: 'Earnings',
    path: '/driver/earnings'
  }, {
    icon: UserIcon,
    label: 'Profile',
    path: '/driver/profile'
  }];
  const navItems = isDriverMode ? driverNavItems : passengerNavItems;
  return <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-primary border-opacity-20 px-2 py-2" data-id="element-39">
      <div className="flex justify-around items-center" data-id="element-40">
        {navItems.map(item => {
        const IconComponent = item.icon;
        const active = isActive(item.path);
        return <Link key={item.path} to={item.path} className={`flex flex-col items-center p-2 ${active ? 'text-primary' : 'text-white text-opacity-60'}`} data-id="element-41">
              <IconComponent size={24} data-id="element-42" />
              <span className="text-xs mt-1" data-id="element-43">{item.label}</span>
            </Link>;
      })}
      </div>
    </div>;
};